import { call, put, takeLatest } from "redux-saga/effects";
import { searchRecipesApi } from "../../../api/recipes";
import { IBaseResponse } from "../../../interfaces/base";
import { IFetchRecipesAction } from "../../../interfaces/store/recipes-interface";
import {
  fetchRecipesSuccess,
  fetchRecipesFailed,
  fetchRecipesStart,
} from "./recipes-slice";

function* _fetchRecipes({ payload }: IFetchRecipesAction) {
  try {
    const { sort, pagination, search } = payload;

    const response: IBaseResponse = yield call(searchRecipesApi, {
      sort: sort || { sortBy: "updatedAt", sortOrder: -1 },
      search,
      pagination,
      filter: {},
    });

    if (response.error) {
      yield put(fetchRecipesFailed(response.error));
    } else {
      yield put(fetchRecipesSuccess({ data: response.data }));
    }
  } catch (error: any) {
    console.log("error:", error);
    yield put(fetchRecipesFailed({ message: error.message }));
  }
}

function* recipesSaga() {
  yield takeLatest(fetchRecipesStart.type, _fetchRecipes);
}

export default recipesSaga;
